/**
 * Average germination time in days for UK garden plants.
 * Used to schedule a "germination check" task after sowing is completed.
 */
const GERMINATION_DAYS: Record<string, number> = {
  // Vegetables
  'Beetroot': 12,
  'Broad Beans': 10,
  'Brussels Sprouts': 10,
  'Cabbage': 10,
  'Carrots': 18,
  'Celeriac': 21,
  'Celery': 21,
  'Chillies': 14,
  'Courgettes': 7,
  'Cucumber': 7,
  'Florence Fennel': 14,
  'Garlic': 14,
  'Globe Artichokes': 14,
  'Kohlrabi': 7,
  'Leeks': 14,
  'Lettuce': 7,
  'Onions': 12,
  'Peas': 10,
  'Potatoes': 21,
  'Pumpkins': 10,
  'Radishes': 5,
  'Runner Beans': 10,
  'Spinach': 10,
  'Sweetcorn': 10,
  'Swiss Chard': 10,
  'Tomatoes': 10,

  // Herbs
  'Basil': 10,
  'Dill': 10,
  'Mint': 14,
  'Parsley': 21,
  'Rosemary': 21,
  'Sage': 14,
  'Tarragon': 14,

  // Flowers
  'Calendula': 10,
  'Marigolds': 7,
  'Nasturtiums': 10,
  'Sunflowers': 7,
};

const DEFAULT_GERMINATION_DAYS = 14;

/**
 * Get the expected germination time for a plant in days.
 */
export function getGerminationDays(plantName: string): number {
  return GERMINATION_DAYS[plantName] ?? DEFAULT_GERMINATION_DAYS;
}
